import { render, staticRenderFns } from "./PlaceRevision.vue?vue&type=template&id=d3e3e5b2"
import script from "./PlaceRevision.vue?vue&type=script&lang=ts"
export * from "./PlaceRevision.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports